export default {
  business: 'Business',
  'get-inspired': 'Inspire-se',
  'how-to': 'Como fazer',
  news: 'Notícias',
  printstories: 'Printstories',
  highlights: 'Destaques',
  'business-growth': 'Crescimento do negócio',
}
